export default __webpack_public_path__ + "static/media/envelope-ticked.111ef8d5.svg";